import { PromotionGetResponseType } from "@sellar-io/api-v2/types";
import { createContext, useContext } from "react";

type PromotionContextType = {
  promotion: PromotionGetResponseType;
};

export const PromotionContext = createContext<PromotionContextType | null>(
  null,
);

export const usePromotionContext = () => {
  const context = useContext(PromotionContext);
  if (!context) {
    throw new Error(
      "usePromotionContext must be within PromotionContextProvider",
    );
  }

  return context;
};
